/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Unauthorized.ts
 */

import APIError from "./APIError";

export default class Unauthorized extends APIError {
    constructor(message: string) {
        super("Non autorisé", 401, message);
    }
}